import { useEffect, useState } from "react";
import { Alert, Center, Loader } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

import { api } from "../../lib";
import {
  clearInternalRenderBootstrapToken,
  getInternalRenderBootstrapToken,
} from "../../lib/internalRenderBootstrap";
import { setRenderMode } from "../../lib/renderModeFlag";
import type { TcTechnicalSummaryProjection } from "../../types/tcTechnicalSummary";
import { TcTechnicalSummaryCapture } from "./TcTechnicalSummaryCapture";
import { TcTechnicalSummaryDocument } from "./TcTechnicalSummaryDocument";

const TOKEN_HEADER = "X-TC-Summary-Render-Token";

export default function RenderTcTechnicalSummaryPage() {
  const [token] = useState(getInternalRenderBootstrapToken);
  const [projection, setProjection] =
    useState<TcTechnicalSummaryProjection | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setRenderMode(true);
    clearInternalRenderBootstrapToken();
    if (!token) {
      setFailed(true);
      return () => setRenderMode(false);
    }
    api
      .get<{ projection: TcTechnicalSummaryProjection }>(
        "/tc-technical-summary-render/context",
        { headers: { [TOKEN_HEADER]: token } }
      )
      .then((context) => {
        if (active) setProjection(context.projection);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
      setRenderMode(false);
    };
  }, [token]);

  if (failed) {
    return (
      <Center h="100vh" data-render-error="true">
        <Alert
          color="red"
          variant="light"
          icon={<IconAlertCircle size={16} />}
          title="Technical Summary rendering failed"
          role="alert"
        >
          The Technical Summary could not be rendered.
        </Alert>
      </Center>
    );
  }
  if (!projection)
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  return (
    <TcTechnicalSummaryCapture>
      <TcTechnicalSummaryDocument projection={projection} />
    </TcTechnicalSummaryCapture>
  );
}
